import { fetchPaginatedGroups } from 'api/groups';

import { useQuery } from 'react-query';

import { washHub } from 'store';

export const useGroups = () => {
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = [`fetch-all-groups`, washHubId];
  const queryFn = () =>
    fetchPaginatedGroups({
      washHub: washHubId,
      limit: 100,
    });
  const options = { enabled: isWashHubIdValid };

  const query = useQuery(queryKey, queryFn, options);

  return query;
};
